import './playground.scss';

import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { Subject } from 'rxjs';
import { throttleTime } from 'rxjs/operators';
import { Component, Prop } from 'vue-property-decorator';

import { AuthService } from '@skinsoft/auth';
import { User } from '@skinsoft/types'
import { fetch, FetchError, Proxy } from '@skinsoft/network';
import { OfflineRibbon, ServiceWorkerLifecycle } from '@skinsoft/offline-mode';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Navbar, SideMenu } from '@skinsoft/ui';

import { FORCE_CLOSE_MENU_TOPIC } from '../../../busTopics'
import { router, Routes } from '../../../router';
import { AlertContainer } from '../../report-edition/alert-container';
import { ActionBar } from '../action-bar';
import { ReportMenu } from '../report-menu';
import { TOGGLE_MENU_TOPIC } from '@skinsoft/bus/src/busTopics';

@Component({
    components: {
        sActionBar: ActionBar,
        sAlertContainer: AlertContainer,
        sNavbar: Navbar,
        sOfflineRibbon: OfflineRibbon,
        sReportMenu: ReportMenu,
        sServiceWorkerLifecycle: ServiceWorkerLifecycle,
        sSideMenu: SideMenu
    },
    props: ['embeddedMode'],
    template: require('./playground.html'),
})
export class Playground extends ReactiveVue {

    @Prop({ type: Boolean, default: false })
    public embeddedMode: boolean;

    public $authService: AuthService;
    public ready: boolean = false;
    public loadingIcon = faCircleNotch;
    public slowNetwork = false;
    public hasContextMenu = false;
    public toggleSideMenuTopic = TOGGLE_MENU_TOPIC;
    public forceCloseMenuTopic = FORCE_CLOSE_MENU_TOPIC;

    private error$ = new Subject<FetchError>();

    public async created() {
        let timeoutId: NodeJS.Timer | null;

        timeoutId = setTimeout(() => {
            this.slowNetwork = true;
            timeoutId = null;
        }, 10e3);

        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        Proxy.onError(error => this.error$.next(error));
        this.subscribeTo(this.error$.pipe(throttleTime(100)), this.onProxyError);
        this.ready = true;
    }

    public mounted() {
        this.subscribeTo(this.$authService.waitForUser$(), this.onUser);
    }

    private onUser(user: User | null) {
        if (user) {
            return;
        }

        if (router.currentRoute.name !== Routes.LOGIN) {
            router.push({ name: Routes.LOGIN });
        }
    }

    private onProxyError(error: FetchError) {
        let message: string;

        switch (error.status) {
            case 404:
                message = this.$t('proxy.error.notFound', { uri: error.uri }) as string;
                break;
            case 401:
                if (router.currentRoute.name === Routes.LOGIN) {
                    return;
                }

                this.$authService.logOut();
                message = this.$t('proxy.error.tokenHasExpired') as string;
                break;
            default:
                if (fetch.isNetworkError(error)) {
                    if (!window.navigator.onLine) {
                        return;
                    }
                    message = this.$t('proxy.error.network') as string;
                } else {
                    return;
                }
                break;
        }

        this.$toasted.show(message, {
            action: [
                {
                    onClick: (_, toastObject) => {
                        toastObject.goAway(0);
                    },
                    text: 'Fermer',
                },
            ],
            duration: 3e3,
            fitToScreen: true,
            fullWidth: true,
            position: 'bottom-center',
            singleton: true,
        });
    }
}
